import { Directive, Attribute, HostListener } from '@angular/core';
import { NgModel, NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[input-field-on-past-filter]'
})
export class LobbyWrapUpputFilterDirective {
    regExpattern: RegExp;

    constructor(private control: NgControl) {
        this.regExpattern = new RegExp('^[^<>&]+$');
    }

    @HostListener('input', ['$event'])
    onInputChange(event: any) {
        if (event.target.value === '' || !event.target.value.replace(/\s/g, '').length) {
            this.control.control?.setValue('');
            event.target.defaultValue = '';
        } else {
            var test = this.regExpattern.test(event.target.value);
            if (test) {
                event.target.defaultValue = event.target.value;
            } else {
                this.control.control?.setValue(event.target.defaultValue);
            }
        }
    }
}
